module.exports = __webpack_public_path__ + "img/2.b36de60a.svg";